module.exports = __webpack_public_path__ + "img/vip_badge_2.055aa37a.png";